module.exports = __webpack_public_path__ + "img/rightsection.b0cd7111.png";